module.exports = __webpack_public_path__ + "img/alert-circle.dc8d719f.svg";